import { render, staticRenderFns } from "./addStaffDialog.vue?vue&type=template&id=5cb616f6&"
import script from "./addStaffDialog.vue?vue&type=script&lang=js&"
export * from "./addStaffDialog.vue?vue&type=script&lang=js&"
import style0 from "./addStaffDialog.vue?vue&type=style&index=0&id=5cb616f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports